
    const firebaseConfig = {
        apiKey: "AIzaSyBJXnTjh0ixCVLI1-pTR9q6LYd3qDigKYs",
        authDomain: "ema-john-8f5c9.firebaseapp.com",
        projectId: "ema-john-8f5c9",
        storageBucket: "ema-john-8f5c9.appspot.com",
        messagingSenderId: "820974582509",
        appId: "1:820974582509:web:3642a252fea824c3416ae4"
      };

export {firebaseConfig}